import React from "react";
import Srcset from "@/components/common/Srcset";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import CheckboxList from "./CheckboxList";
import { generalConstants } from "@/utils/constants/general";

function FilterSection({
  title,
  options,
  selected,
  facetKey,
  open,
  onToggle,
  onChange,
  getLabel,
  getColor,
  styleClass,
  selectedCount,
  onSearch,         
  searchValue,      
  searchPlaceholder,
  showPriceRange,
  priceMin,
  priceMax,
  onPriceInputChange,
  pricePointsDisabled,
  onPriceInputFocus,
  onPriceInputBlur,
  hiddenFiltersState,
}) {
  // Only return null if options is null or undefined, not if it's an empty array
  if (options == null) return null;
  // Search config (can be reused for any filter)
  const showSearch = Boolean(onSearch);
  const searchProps = showSearch
    ? {
        showSearch: true,
        onSearch,
        searchValue,
        searchPlaceholder: searchPlaceholder || "Search...",
      }
    : {};

  const showPrice = Boolean(showPriceRange);
  const priceProps = showPrice
    ? {
        showPriceRange: true,
        priceMin,
        priceMax,
        onPriceInputChange,
        pricePointsDisabled,
        onPriceInputFocus,
        onPriceInputBlur,
      }
    : {};

  // Determine extra class for filter identification
  let extraClass = '';
  if (facetKey === generalConstants.FILTER_KEYS.AVAILABILITY) {
    if (hiddenFiltersState?.availability) extraClass = ' hide_filter';
  } else if (facetKey === generalConstants.FILTER_KEYS.MATERIAL) {
    if (hiddenFiltersState?.material) extraClass = ' hide_filter';
  } else if (facetKey === generalConstants.FILTER_KEYS.STONE) {
    if (hiddenFiltersState?.stone) extraClass = ' hide_filter';
  } else if (facetKey === generalConstants.FILTER_KEYS.SLEEVES) {
    if (hiddenFiltersState?.sleeves) extraClass = ' hide_filter';
  }

  return (
    <div className={styles.filter_item + (open ? " active" : "") + (extraClass ? ` ${extraClass}` : '')}>
      <div className={styles.filter_item_head} onClick={onToggle}>
        <div className={`${styles.filter_item_title} normal-sm normal-md small-xs`}>{title}</div>
        <div className={styles.filter_item_action}>
          {selectedCount > 0 && (
            <span className={`${styles.filter_action_txt} text-10 filter_count`}>
              {selectedCount} {selectedCount === 1 ? "filter" : "filters"} selected
            </span>
          )}
          <span className={styles.filter_action_plus}>
            <Srcset
              height="15"
              width="15"
              alt="Account"
              requirePath={true}
              svgFile={true}
              src={"images/Icons/Cross/Large.svg"}
            />
          </span>
        </div>
      </div>
      {open && (
        <div className={styles.filter_item_body}>
          <CheckboxList
            options={options}
            selected={selected}
            facetKey={facetKey}
            onChange={onChange}
            getLabel={getLabel}
            getColor={getColor}
            styleClass={styleClass}
            {...searchProps}
            {...priceProps}
          />
        </div>
      )}
    </div>
  );
}

export default FilterSection;